/**
 * Inserts `scale-internal` into an edge URL so traffic routes via Tailscale.
 * e.g. mediamtx.southshore-germanium.edge.scaleaq.net
 *   -> mediamtx.scale-internal.southshore-germanium.edge.scaleaq.net
 *
 * Matches any edge DNS zone (`edge.scaleaq.net`, `edge.scaleaq-dev.net`, ...).
 * Returns the original URL unchanged if it already contains scale-internal or isn't an edge URL.
 */
export const addScaleInternalToUrl = (url: string): string =>
  url.replace(
    /^(https?:\/\/[^.]+\.)((?!scale-internal\.)[^/]*\.edge\.[^/]+)/,
    '$1scale-internal.$2'
  );
